import useJwt from '@/auth/jwt/useJwt'
import ability from '@/libs/acl/ability'
import { initialAbility } from '@/libs/acl/config'
import { canEnterAdmin, markAbilitiesLoaded, refreshAbilities } from '@/auth/abilities'

/**
 * After a successful POST /authentication/log-in: keep the tokens and the user, then take the rights from the API
 * (not from users.role). Without `admin:access` the session is dropped at once: the admin panel is not for them.
 */
export const completeAdminLogin = async response => {
  const userData = response.data.user
  useJwt.setToken(response.data.accessToken)
  useJwt.setRefreshToken(response.data.refreshToken)
  localStorage.setItem('userData', JSON.stringify(userData))

  const abilities = await refreshAbilities(userData)
  markAbilitiesLoaded(abilities)
  if (!canEnterAdmin(abilities)) {
    useJwt.logout()
    ability.update(initialAbility)
    return { allowed: false, userData }
  }
  return { allowed: true, userData: JSON.parse(localStorage.getItem('userData')) }
}

export const NO_ADMIN_ACCESS = 'У этой учётной записи нет доступа к админке. Права выдаёт администратор в разделе «Роли и права».'
